export default "__VITE_ASSET__R3_ARrO2__"